import { Component, OnInit, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Investor } from '../../shared/models/investor';

@Component({
  selector: 'app-income-details',
  templateUrl: './income-details.component.html',
  styleUrls: ['./income-details.component.css']
})
export class IncomeDetailsComponent implements OnInit, OnChanges {
  salaryValue: number;
  proIncomeValue: number;
  interestsValue: number;
  rentalValue: number;
  otherMiscValue: number;
  dayToDayValue: number;
  insuranceValue: number;
  eduValue: number;
  homeCarValue: number;
  otherMiscExpenseValue: number;
  standard_monthly_expenses = standard_expenses;
  standard_monthly_incomes = standard_incomes;
  surplusAmount: number;
  annualSurplusAmount: number;
  maxAnnualInvestableSIP: number;
  surplusAmountToUse: number;
  showSpouseModal: boolean;
  hasSpouse: boolean;
  activeTab: string;
  hasUserChangedAnnualInvestableSIP: boolean;

  @Input()
  investor: Investor;
  @Input() flags: any;

  constructor(private changeDetRef: ChangeDetectorRef) {
    this.surplusAmountToUse = 0;
    this.surplusAmount = 0;
    this.annualSurplusAmount = 0;
    this.maxAnnualInvestableSIP = 0;
    this.hasUserChangedAnnualInvestableSIP = false;
   }

  ngOnInit() {
    this.activeTab = 'main';
    this.salaryValue = 0;
    this.proIncomeValue = 0;
    this.interestsValue = 0;
    this.rentalValue = 0;
    this.otherMiscValue = 0;
    this.dayToDayValue = 0;
    this.insuranceValue = 0;
    this.eduValue = 0;
    this.homeCarValue = 0;
    this.otherMiscExpenseValue = 0;
    this.showSpouseModal = false;
    this.hasSpouse = this.investor.spouse_name !== '';
    this.initIncomesExpenses();
    this.calculateSurplusAmount();
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  initIncomesExpenses() {
    if (!this.investor.incomes.hasOwnProperty('main')) {
      this.investor.incomes['main'] = JSON.parse(JSON.stringify(standard_incomes));
      this.investor.expenses['main'] = JSON.parse(JSON.stringify(standard_expenses));
    }
    if (this.hasSpouse && !this.investor.incomes.hasOwnProperty('spouse')) {
      this.investor.incomes['spouse'] = JSON.parse(JSON.stringify(standard_incomes));
      this.investor.expenses['spouse'] = JSON.parse(JSON.stringify(standard_expenses));
    }
    // this.incomes = this.investor.incomes['main'];
    // this.expenses = this.investor.expenses['main'];
  }

  getIncomes() {
    return this.activeTab === 'main' ? this.investor.incomes['main'] : this.investor.incomes['spouse'];
  }
  getExpenses() {
    return this.activeTab === 'main' ? this.investor.expenses['main'] : this.investor.expenses['spouse'];
  }

  updateUI($event) {
    this.calculateSurplusAmount();
  }
  changedAnnualSIP($event){
    this.hasUserChangedAnnualInvestableSIP = true;
  }
  onAgeValueChange($event) {
    console.log($event);
  }
  calculateSurplusAmount() {
    setTimeout(() => {
      const surplusAmount = 0;
      // tslint:disable-next-line:radix
      let incomes = this.investor.incomes['main'];
      let expenses = this.investor.expenses['main'];
      const totalMainIncome = incomes.map(inc => parseInt(inc.value) || 0).reduce((val1, val2) => val1 + val2, 0);
      // tslint:disable-next-line:radix
      const totalMainExpense = expenses.map(ex => parseInt(ex.value) || 0).reduce((val1, val2) => val1 + val2, 0);
      this.investor.total_main_income = totalMainIncome;
      this.investor.total_main_expenditure = totalMainExpense;
      // console.log(incomes);
      if (this.hasSpouse) {
        const totalSpouseIncome = this.investor.incomes['spouse']
                                      .map(inc => parseInt(inc.value) || 0).reduce((val1, val2) => val1 + val2, 0);
        const totalSpouseExpense = this.investor.expenses['spouse']
                                        .map(ex => parseInt(ex.value) || 0).reduce((val1, val2) => val1 + val2, 0);
        this.investor.total_spouse_income = totalSpouseIncome;
        this.investor.total_spouse_expenditure = totalSpouseExpense;
        incomes = incomes.concat(this.investor.incomes['spouse']);
        expenses = expenses.concat(this.investor.expenses['spouse']);
      }
      
      // console.log(incomes);
      const totalIncome = incomes.map(inc => parseInt(inc.value) || 0).reduce((val1, val2) => val1 + val2, 0);
      // tslint:disable-next-line:radix
      const totalExpense = expenses.map(ex => parseInt(ex.value) || 0).reduce((val1, val2) => val1 + val2, 0);
      this.investor.total_salary_professional_income = incomes.filter(i => i.name === 'salary' || i.name === 'professional_income')
                                                              .map(inc => parseInt(inc.value) || 0)
                                                              .reduce((val1, val2) => val1 + val2, 0);
      this.investor.total_income = totalIncome;
      this.investor.total_expenditure = totalExpense;
      this.surplusAmount = totalIncome - totalExpense;
      this.investor.surplus_amount = this.surplusAmount;
      this.investor.total_annual_surplus_amount = this.annualSurplusAmount = this.surplusAmount * 12;
      this.getTotalEmergencyFunds();
      if((!this.investor.iid && !this.hasUserChangedAnnualInvestableSIP) || (this.maxAnnualInvestableSIP < this.investor.total_investing_SIP_amount)){
        this.investor.total_investing_SIP_amount = this.maxAnnualInvestableSIP;
      }
      this.changeDetRef.detectChanges();
      return this.surplusAmount;
    });
  }

  getTotalMonthlyIncome() {
    const incomes = this.investor.incomes[this.activeTab];
    return incomes.map(inc => parseInt(inc.value) || 0).reduce((val1, val2) => val1 + val2, 0);
  }

  getTotalMonthlyExpense() {
    const expenses = this.investor.expenses[this.activeTab];
    return expenses.map(inc => parseInt(inc.value) || 0).reduce((val1, val2) => val1 + val2, 0);
  }

  switchTabs(tab) {
    this.activeTab = tab;
    this.calculateSurplusAmount();
  }
  registerSpouse() {
    if (this.investor.spouse_name !== '') {
      this.showSpouseModal = false;
      this.hasSpouse = true;
      if (this.hasSpouse && !this.investor.incomes.hasOwnProperty('spouse')) {
        this.investor.incomes['spouse'] = JSON.parse(JSON.stringify(standard_incomes));
        this.investor.expenses['spouse'] = JSON.parse(JSON.stringify(standard_expenses));
      }
    }
  }

  removeSpouse() {
    this.hasSpouse = false;
    this.investor.spouse_name = '';
    this.investor.incomes['spouse'] = [];
    this.investor.expenses['spouse'] = [];
    this.activeTab = 'main';
    // this.incomes = this.investor.incomes[this.activeTab];
    // this.expenses = this.investor.expenses[this.activeTab];
    this.calculateSurplusAmount();
  }

  getTotalEmergencyFunds() {
    this.investor.total_emergency_funds = this.investor.total_expenditure * this.investor.emergency_funds_multiplier || 0;
    this.maxAnnualInvestableSIP = this.annualSurplusAmount - this.investor.total_emergency_funds;
    return this.investor.total_emergency_funds;
  }
  calculateAnnualSurplusAmount() {

  }
}

const standard_incomes = [
  {
    'name': 'salary',
    'label': 'Salary/Renumeration',
    'value': null
  },
  {
    'name': 'professional_income',
    'label': 'Professional Income/Fees',
    'value': null
  },
  {
    'name': 'interests_dividend',
    'label': 'Interest/Dividend',
    'value': null
  },
  {
    'name': 'rental_income',
    'label': 'Rental Income',
    'value': null
  },
  {
    'name': 'other_misc_incomes',
    'label': 'Other Misc Incomes if any',
    'value': null
  },
];

const standard_expenses = [
  {
    'name': 'food',
    'label': 'Food',
    'small_description': 'Food and glorious food, Groceries, Restaurants and takeout',
    'value': null
  },
  {
    'name': 'accommodation',
    'label': 'Accommodation',
    'small_description': 'Rent, Home loan EMI, Maintenance and repairs, Insurance premiums for home, \
                          Property taxes, Heat, Electricity, Water and gas bills, Phone, Cable and internet, Other',
    'value': null
  },
  {
    'name': 'house_hold_operations',
    'label': 'House Hold Operations',
    'small_description': 'Domestic help, Child care expenses, Animal care expenses, Cleaning products, Others',
    'value': null
  },
  {
    'name': 'furniture_equipments',
    'label': 'Furniture And Equipments',
    'small_description': 'New, repaint and repair etc, Accessories and decorative items',
    'value': null
  },
  {
    'name': 'style',
    'label': 'Style',
    'small_description': 'Clothing (Purchase and Cleaning), Shoes, Glasses, Jewellery (Watches and Earrings)',
    'value': null
  },
  {
    'name': 'transportation',
    'label': 'Transportation',
    'small_description': 'Automobile Purchase(Cash), Vehicle Loan EMI, Insurance Premium/Permits, Maintenance and repairs, \
                          Oil, Fuel, GAS etc, Parking and Tolls, Public/Hired Transit (Bus/Auto/Taxi/Subway fares)',
    'value': null
  },
  {
    'name': 'health_care',
    'label': 'Health Care',
    'small_description': 'Physician and Hospitals, Health Insurance Premium, Therapy, Vaccination, \
                          Dental and Vision etc, Non refundable medical expenses',
    'value': null
  },
  {
    'name': 'personal_care',
    'label': 'Personal Care',
    'small_description': 'Hair Cuts/Hair Care, Aesthetician, Beauty Products, Supplies and Other Services, Health Club and or Gym',
    'value': null
  },
  {
    'name': 'leisure_entertainment',
    'label': 'Leisure and Entertainment',
    'small_description': 'Leisure Vehicles, Sports, Camping shows and outing, Books, Newspapers, CDs, Gadgets etc, \
                          Phone and accessories, Collections and Crafts, Vacation, Trips, Hobbies, Subscription/Memberships, Others',
    'value': null
  },
  {
    'name': 'education',
    'label': 'Education',
    'small_description': 'Tuition Fees, Books Stationary Supplies, Other Activities',
    'value': null
  },
  {
    'name': 'contributions_gift',
    'label': 'Contributions, Gift',
    'small_description': '',
    'value': null
  },
  {
    'name': 'donations',
    'label': 'Donations',
    'small_description': '',
    'value': null
  },
  {
    'name': 'tobacco_alcohol',
    'label': 'Tobacco and Alcohol',
    'small_description': '',
    'value': null
  },
  {
    'name': 'short_term_loan',
    'label': 'Short Term Loan',
    'small_description': '',
    'value': null
  },
  {
    'name': 'income_tax',
    'label': 'Income Tax',
    'small_description': '',
    'value': null
  },
  {
    'name': 'financial_security',
    'label': 'Financial Security',
    'small_description': 'Life Insurance Premium, Accident Premium, Liability Insurance, \
                          SIP Input Value, Employment Insurance, Pension Plan, Pension Contributions, Other',
    'value': null
  },
  {
    'name': 'miscellaneous',
    'label': 'Miscellaneous',
    'small_description': 'Financial Advisor Fees, Profesional Fees, Others',
    'value': null
  }
];



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/income-details/income-details.component.ts